// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const EmptyWalletIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "EmptyWallet/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.375 3.292v3.166h-1.25V3.292c0-.225-.2-.334-.333-.334a.334.334 0 0 0-.125.025L4.058 5.475a1.12 1.12 0 0 0-.725 1.058v.559a3.113 3.113 0 0 0-1.25 2.5V6.533c0-.991.609-1.875 1.534-2.225l6.616-2.5a1.588 1.588 0 0 1 2.142 1.483ZM17.917 12.083v.834a.416.416 0 0 1-.409.416h-1.216c-.442 0-.842-.325-.875-.758a.832.832 0 0 1 .241-.667.792.792 0 0 1 .584-.241H17.5a.418.418 0 0 1 .417.416Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.233 10.792h.85a.836.836 0 0 0 .834-.834v-.366a3.14 3.14 0 0 0-3.134-3.134H5.217c-.709 0-1.359.234-1.884.634a3.113 3.113 0 0 0-1.25 2.5V15.2a3.14 3.14 0 0 0 3.134 3.133h9.566a3.14 3.14 0 0 0 3.134-3.133v-.158a.836.836 0 0 0-.834-.834h-.725c-.8 0-1.566-.491-1.775-1.266a1.665 1.665 0 0 1 .45-1.65 1.66 1.66 0 0 1 1.2-.5Zm-4.566-.167H5.833A.63.63 0 0 1 5.208 10a.63.63 0 0 1 .625-.625h5.834a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625Z"
}));
export default EmptyWalletIcon;